import React, {Component} from 'react';
import {ACTION_TYPES, actions} from "../../actions";
import {connect} from "react-redux";
import Rubrics from '../rubric/Rubrics';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import {withStyles} from "@material-ui/core/styles/index";
import Typography from '@material-ui/core/Typography';
import {isAllowed, ROLES, withRoles} from "../Permissions";
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import _ from 'lodash';
import RubricList from './RubricsList';
import ValidationSnackBar from '../parts/ValidationSnackBar';
import {GENED_ID} from '../../constants'

const styles = {
    card: {
        minWidth: 275,
        marginBottom: 15
    },
    title: {
        marginTop: 5,
        marginBottom: -2,
        fontSize: 12,
    },
    p: {
        marginBottom: 5
    },
    headertitle: {
        fontSize: 'x-large',
        color: '#000',
        backgroundColor: '#fff',
        padding: 16,
        marginBottom: -25
    }

};

const showDiv = (user, compRoles, component) => {
    if(isAllowed(user, compRoles)) {
        return component;
    } else {
        return null;
    }
};

const DEFAULT_CRITERION = {
    criteria_title: "New Criterion",
    ratings: [
        {rating_title: "No Marks", rating_description: "Describe your lowest rating here", points: 0},
        {rating_title: "Full Marks", rating_description: "Describe your highest rating here", points: 5}
    ],
    max_points: 5
};

class RubricDashboard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
            department: {name:''},
            program: {name:''},
            college:{name:''},
            outcome:{name:''},
            name: '',
            criteriaTitlesNotUniqueSnackBarOpen: false,
            inCompleteFormSnackBarOpen: false,
            rubricNameSnackBarOpen: false
        };
        this.handleSave = this.handleSave.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }

    handleNameChange = () => (event) => {
        this.setState({name: event.target.value});
    }

    setStateAsync(state) {
        return new Promise((resolve) => {
            this.setState(state, resolve)
        });
    }

    async componentDidMount() {
        if(this.props.user.roles.includes(ROLES.ADMIN) || this.props.user.roles.includes(ROLES.COORDINATOR)) {
            await this.props.fetchColleges();
            let college = this.filterList(this.props.colleges);
            if(college) {
                this.setState({college: college});
                await this.props.fetchDepartments(college.id);
            }
        } else {
            await this.props.fetchDepartmentsPerUser();
        }

        let department = this.filterList(this.props.departments);
        if(department) {
            this.setState({department: department});
            await this.props.fetchPrograms(department.id);
        }

        this.props.resetRubrics(DEFAULT_CRITERION);
        this.props.resetRubricsList();

    }

    filterList(list) {
        if(list && list.length > 0) {
            return list[0];
        }
        return null;
    }

    renderList(list) {
        return _.map(list, option => {
            return (
                <MenuItem key={option.id} data-key={option.id} value={option.name} style={{width:'250'}}>
                    {option.name}
                </MenuItem>
            );
        });
    }

    handleChange = (name) => async (event) => {
        const query = event.nativeEvent.target.getAttribute('data-key');
        this.setState({
            [name]: {
                name: event.target.value,
                id: query
            }
        });
        switch(name) {
            case 'college':
                await this.props.fetchDepartments(query);
                var department = this.filterList(this.props.departments);
                if(department) {
                    await this.setStateAsync({department: department});
                    await this.props.fetchPrograms(department.id);
                }

                var program = this.filterList(this.props.programs);
                if(program) {
                    await this.setStateAsync({program: program});
                    await this.props.fetchOutcomes(program.id);
                }

                var outcome = this.filterList(this.props.outcomes);
                if(outcome) {
                    await this.setStateAsync({outcome: outcome});
                    this.props.fetchRubrics(this.state.outcome.id);
                } else {
                    await this.props.setNewFields({
                        type: ACTION_TYPES.FETCH_RUBRICS,
                        payload: []
                    })
                }
                break;
            case 'department':
                await this.props.fetchPrograms(query);
                var program = this.filterList(this.props.programs);
                if(program) {
                    await this.setStateAsync({program: program});
                    await this.props.fetchOutcomes(program.id);
                }

                var outcome = this.filterList(this.props.outcomes);
                if(outcome) {
                    await this.setStateAsync({outcome: outcome});
                    this.props.fetchRubrics(this.state.outcome.id);
                } else {
                    await this.props.setNewFields({
                        type: ACTION_TYPES.FETCH_RUBRICS,
                        payload: []
                    })
                }
                break;
            case 'program':
                await this.props.fetchOutcomes(query);
                var outcome = this.filterList(this.props.outcomes);
                if(outcome) {
                    await this.setStateAsync({outcome: outcome});
                    this.props.fetchRubrics(this.state.outcome.id);
                } else {
                    await this.props.setNewFields({
                        type: ACTION_TYPES.FETCH_RUBRICS,
                        payload: []
                    })
                }
                break;
            case 'outcome':
                this.setState({
                    [name]: {
                        name: event.target.value,
                        id: query
                    }
                }, () => {
                    this.props.fetchRubrics(this.state.outcome.id);
                })
                break;
            case 'name':
                this.setState({name: event.target.value})
            default:
        }

    };

    renderSnackBars() {
        return (<div>
            <ValidationSnackBar variant="error" message={"Incomplete Form"} open={this.state.inCompleteFormSnackBarOpen} onClose={this.handleClose}/>
            <ValidationSnackBar variant="error" message={"Criteria titles are not unique"} open={this.state.criteriaTitlesNotUniqueSnackBarOpen} onClose={this.handleClose}/>
            <ValidationSnackBar variant="error" message={"Rubric must have a name"} open={this.state.rubricNameSnackBarOpen} onClose={this.handleClose}/>
        </div>)
    }

    renderOutcomeList(list) {
        let genedOutcomes = [];
        let programOutcomes = [];
        let outcomes = [];

        _.map(list, option => {
            if(option.type == 'General Education') {
                genedOutcomes.push(<MenuItem key={option.id} data-key={option.id} value={option.name} style={{width:'250'}}>
                    {option.name}
                </MenuItem>)
            } else {
                programOutcomes.push(<MenuItem key={option.id} data-key={option.id} value={option.name} style={{width:'250'}}>
                    {option.name}
                </MenuItem>)
            }
        });
        if(this.state.program.id == GENED_ID) {
            outcomes.push(<MenuItem disabled={true} key={'gen-ed-title'} value={'gen-ed-title'} style={{width:'250'}}>
                General Education Outcomes
            </MenuItem>);

            outcomes.push(...genedOutcomes);
        } else {
            outcomes.push(<MenuItem disabled={true} key={'program-outcome-title'} value={'program-outcome-title'} style={{width:'250'}}>
                Program Outcomes
            </MenuItem>);

            outcomes.push(...programOutcomes);
        }


        return outcomes;
    }

    handleSave() {
        let rubric = {
            outcome_id: this.state.outcome.id,
            criterions: this.props.rows,
            name: this.state.name,
            createdBy: this.props.user.unid
        };
        if(this.validation()) {
            this.props.saveRubric(rubric).then(() => {
                this.props.fetchRubrics(this.state.outcome.id);
            })
        }

    }

    validation() {

        if(this.state.outcome.name.length < 1) {
            this.setState({inCompleteFormSnackBarOpen: true})
            return false;
        }

        if(this.state.name.length < 1) {
            this.setState({rubricNameSnackBarOpen: true})
            return false;
        }

        // unique rubrics criteria titles
        if (this.props.rubrics) {
            const titlesArr = this.props.rubrics.map(rubric => rubric.criteria_title);
            const titlesSet = new Set(titlesArr);
            if (titlesSet.size !== titlesArr.length) {
                this.setState({criteriaTitlesNotUniqueSnackBarOpen: true});
                return false;
            }
        }

        return true;
    }

    handleSelect(row) {
        this.props.updateRubrics(row.criterions);
        this.setState({name: row.name});
    };

    handleDelete(row) {
        this.props.deleteRubric(row._id).then(() => {
            this.props.fetchRubrics(this.state.outcome.id);
        })
    }

    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        this.setState({
            inCompleteFormSnackBarOpen: false,
            criteriaTitlesNotUniqueSnackBarOpen: false,
        });
    };

    render() {
        const {classes} = this.props;
        return (
            <div>
                <Typography variant="h3" gutterBottom>
                    Rubrics
                </Typography>
                <div className='row'>
                    <div className='columnLeft'>
                        <Card className={classes.card}>
                            <Typography variant="h5" gutterBottom className={classes.headertitle}>
                                Select an Outcome
                            </Typography>

                            <CardContent>
                                {showDiv(
                                    this.props.user,
                                    [ROLES.COORDINATOR, ROLES.ADMIN],
                                    <div>
                                        <TextField id="select-college" select label="Select College" style={{width:'400px'}} value={this.state.college.name} onChange={this.handleChange('college')} margin="normal">
                                            {this.renderList(this.props.colleges)}
                                        </TextField>
                                    </div>
                                )}

                                <div>
                                    <TextField id="select-department" select label="Select Department" style={{width:'400px'}} value={this.state.department.name} onChange={this.handleChange('department')} margin="normal">
                                        {this.renderList(this.props.departments)}
                                    </TextField>
                                </div>

                                <div>
                                    <TextField id="select-program" select label="Select Program" style={{width:'400px'}} value={this.state.program.name} onChange={this.handleChange('program')} margin="normal">
                                        {this.renderList(this.props.programs)}
                                    </TextField>
                                </div>
                                <div>
                                    <TextField id="select-outcome" select label="Select Outcome" style={{width:'400px'}} value={this.state.outcome.name} onChange={this.handleChange('outcome')} margin="normal">
                                        {this.renderOutcomeList(this.props.outcomes)}
                                    </TextField>
                                </div>
                            </CardContent>
                        </Card>
                    </div>
                    <div className='columnRight'>
                        <Card className={classes.card}>
                            <Typography variant="h5" gutterBottom className={classes.headertitle}>
                                Rubrics
                            </Typography>
                            <CardContent>
                                <RubricList handleSelect={this.handleSelect} handleDelete={this.handleDelete} showActions={true}/>
                            </CardContent>
                        </Card>
                    </div>
                </div>
                    <Card className={classes.card}>
                        <Typography variant="h5" gutterBottom className={classes.headertitle}>
                            Rubrics
                        </Typography>
                        <CardContent>
                            <div>
                                <TextField id="standard-name" label="Name"style={{width:'400px'}} value={this.state.name} onChange={this.handleNameChange()} margin="normal"/>
                            </div>
                            <Rubrics showSave={true} handleSave={this.handleSave}/>
                        </CardContent>
                    </Card>
                {this.renderSnackBars()}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        form: state.newAssessmentForm,
        reviewers: state.reviewers,
        artifacts: state.artifacts,
        rubrics: state.rubrics,
        rubricsList: state.rubricsList,
        courses: state.courses,
        user: state.user,
        rows: state.rubrics,
        colleges: state.colleges, departments: state.departments, outcomes: state.outcomes, programs: state.programs
    };
}

export default connect(mapStateToProps, actions)(withStyles(styles)(withRoles([ROLES.COORDINATOR,ROLES.DEPARTMENTCOORDINATOR, ROLES.ADMIN])(RubricDashboard)));
